<template>
  <div class="main background-gradient">
    <div class="containerBlock">
      
      <div class="methodsDeposit" v-if="paymentChannels.length">
        <ul class="eWalletList online-entry-list">
          <li :class="['wallet-item', 'online-entry', 'active', { 'usdt-entry': isUsdtChannel(selectedChannel), 'offline-entry': isOfflineQrChannel(selectedChannel) }]">
            <div class="bonus-ribbon"><span>{{ selectedRibbonText }}</span></div>
            <div class="method-content">
              <div class="img-box">
                <img :src="selectedChannelIcon" :alt="selectedChannelName" @error="onSelectedIconError">
              </div>
              <span class="method-name">{{ selectedChannelName }}</span>
              <span class="method-subtitle">{{ selectedChannelSubtitle }}</span>
            </div>
            <div class="check-mark"></div>
          </li>
        </ul>
      </div>

      <div class="depositAmountSet" v-if="paymentChannels.length">
        <div class="amount-header">
          <span class="title">{{ $t('Deposit Amount') }}</span>
          <span class="amount-header-tip">先输入金额或点选区间，再选择支付通道</span>
        </div>
        
        <div class="amount-input-wrapper">
          <span class="currency">¥</span>
          <input 
            type="number" 
            v-model="depositAmount" 
            class="amount-input"
            placeholder="0.00"
            inputmode="decimal"
            step="0.01"
            min="0.01"
            max="999999"
          >
        </div>
        
        <div class="quick-amount-grid" v-if="selectedPaymentMethod && hasQuickAmounts">
          <span
            v-for="item in selectedPaymentMethod.amount_list"
            :key="item.amount"
            @click="selectAmount(item.amount)"
            :class="['quick-btn', { active: depositAmount == item.amount }]"
          >{{ formatAmount(item.amount) }}</span>
        </div>
        <div class="offline-range-grid" v-if="isOfflineQrChannel(selectedPaymentMethod) && selectedPaymentMethod.amount_ranges && selectedPaymentMethod.amount_ranges.length">
          <span
            v-for="(range, idx) in selectedPaymentMethod.amount_ranges"
            :key="'range-' + idx"
            :class="['range-chip', { active: isAmountInRange(depositAmount, range) }]"
            @click="selectAmount(range.min_amount)"
          >{{ formatAmount(range.min_amount) }}-{{ formatAmount(range.max_amount) }}</span>
        </div>
        <div class="usdt-convert-hint" v-if="usdtConvertHint">
          {{ usdtConvertHint }}
        </div>
        <div class="amount-hint" v-if="rangeHint">
          {{ rangeHint }}
        </div>
      </div>

      <div class="channel-picker" v-if="paymentChannels.length">
        <div class="channel-picker-header">
          <span>选择支付通道</span>
          <small v-if="depositAmount">已按金额筛选</small>
        </div>
        <div class="channel-list" v-if="availableChannels.length">
          <button
            v-for="channel in availableChannels"
            :key="(channel.type || 'pay') + '-' + channel.id"
            type="button"
            :class="['channel-card', { active: selectedPaymentMethod && selectedPaymentMethod.id === channel.id && selectedPaymentMethod.type === channel.type, 'is-usdt': isUsdtChannel(channel), 'is-offline': isOfflineQrChannel(channel) }]"
            @click="selectPaymentMethod(channel)"
          >
            <span class="channel-card-icon">
              <img :src="channel.img || getChannelFallbackIcon(channel)" alt="" @error="onChannelIconError($event, channel)">
            </span>
            <span class="channel-card-main">
              <strong>{{ channel.name }}</strong>
              <em v-if="isUsdtChannel(channel)">转账后上传凭证 · 后台审核到账</em>
              <em v-else-if="isOfflineQrChannel(channel)">按金额区间出对应二维码 · 转账后上传凭证</em>
              <em v-else>编码 {{ channel.channel_code }}</em>
            </span>
            <span class="channel-card-meta">
              <span v-if="isUsdtChannel(channel)" class="channel-tag">USDT线下</span>
              <span v-else-if="isOfflineQrChannel(channel)" class="channel-tag offline-tag">{{ offlineChannelTag(channel) }}</span>
              <span class="channel-card-rule">{{ formatChannelRule(channel) }}</span>
            </span>
            <span class="channel-card-arrow">›</span>
          </button>
        </div>
        <div v-else class="channel-empty">当前金额没有可用通道，请调整金额</div>
      </div>
      
      <div class="submit-action" v-if="paymentChannels.length">
        <button 
          :class="['btn-submit', { disabled: !canSubmit, 'btn-usdt': isUsdtChannel(selectedPaymentMethod), 'btn-offline': isOfflineQrChannel(selectedPaymentMethod) }]"
          @click="confirmDeposit"
        >
          <span class="btn-text">{{ submitButtonText }}</span>
          <span class="btn-light"></span>
        </button>
      </div>

      <div class="empty-tip" v-else>暂无可用支付通道，请稍后重试</div>
      
    </div>
  </div>
</template>

<script>
export default {
  name: 'recharge',
  data() {
    return {
      pay_way: '',
      bankBox: {},
      payInfo: {},
      amount: null,
      cardLis: [],
      banklist: [],
      meyXi: 'TRC20',
      payWayList: {},
      payTypeList: [],
      payMethods: {},
      currentPayMethods: [],
      selectedMethod: null,
      show: false,
      userbank: [],
      userUSD: [1],
      min_price: 100,
      max_price: 10000,
      currentTab: '',
      allPaymentMethods: [],
      onlineChannels: [],
      paymentChannels: [],
      selectedPaymentMethod: null,
      depositAmount: '',
    };
  },
  created() {
    this.loadCategories();
  },
  methods: {
    loadCategories() {
      this.currentTab = 'hot';
      this.getPaymentMethodsFromBackend();
    },
    selectTab(tabKey) {
      if (this.currentTab === tabKey) return;
      this.currentTab = tabKey;
      this.selectedPaymentMethod = null;
      this.selectedMethod = null;
      this.amount = null;
      this.depositAmount = '';
      this.getPaymentMethodsFromBackend();
    },
    getPaymentMethodsFromBackend() {
      let that = this;
      that.showLoading();

      // 不按 hot 分类过滤，否则微信/支付宝线下扫码（category=wechat/alipay）会被丢掉。
      that.$apiFun.get('/api/getAllPaymentMethods', { include_usdt: 1 })
        .then((res) => {
          const source = res && res.code == 200 && Array.isArray(res.data) ? res.data : [];
          const methods = source.map((item) => that.normalizePaymentMethod(item));
          const seen = {};
          const offline = [];
          const usdt = [];
          const online = [];

          methods.forEach((item) => {
            const key = `${item.type}-${item.id}`;
            if (seen[key]) return;
            seen[key] = true;
            if (that.isUsdtChannel(item)) {
              usdt.push(item);
            } else if (that.isOfflineQrChannel(item)) {
              offline.push(item);
            } else if (item.isOnline) {
              online.push(item);
            }
          });

          that.allPaymentMethods = offline.concat(usdt).concat(online);
          that.onlineChannels = online;
          that.paymentChannels = that.allPaymentMethods;
          that.selectedPaymentMethod = null;
          that.selectedMethod = null;
          that.hideLoading();
        })
        .catch(() => {
          that.allPaymentMethods = [];
          that.onlineChannels = [];
          that.paymentChannels = [];
          that.selectedPaymentMethod = null;
          that.hideLoading();
        });
    },
    getPayRange() {
      // 金额范围以当前选中通道为准，不再走旧硬编码接口
      if (this.selectedPaymentMethod) {
        this.min_price = this.selectedPaymentMethod.min_price || 0;
        this.max_price = this.selectedPaymentMethod.max_price || 0;
      }
    },
    changShow() { this.show = !this.show; },
    onConfirm(value, index) {
      this.bankBox.bank = value.bank_name;
      this.show = false;
    },
    onChange(picker, value, index) {},
    onCancel() { this.show = false; },
    changXiyi(val) {
      if (this.meyXi == val) return;
      this.meyXi = val;
    },
    getPayWay() {
      // 旧接口保留兼容，主流程已改用 getPaymentCategories
    },
    getPayMethods() {},
    selectMethod(method) {
      this.selectedMethod = method;
    },
    getDefaultIcon(type) {
      const iconMap = {
        'bank': '/static/image/icoOnlineTransfer2@3x.png',
        'card': '/static/image/icoOnlineTransfer2@3x.png',
        'usdt': '/static/image/1595237922936176.png',
        'wechat': '/static/image/QuickWechat.png',
        'wxpay': '/static/image/QuickWechat.png',
        'alipay': '/static/image/QuickAlipay.png',
        'online': '/static/image/iconXunipay@3x.png',
        'online_pay': '/static/image/iconXunipay@3x.png',
        'hot': '/static/image/icoOnlineTransfer2@3x.png',
        'wallet': '/static/image/icoOnlineTransfer2@3x.png',
        'other': '/static/image/icoOnlineTransfer2@3x.png',
      };
      return iconMap[type] || '/static/image/icoOnlineTransfer2@3x.png';
    },
    getMethodChannel(method) {
      const source = method || {};
      return String(
        source.pay_way ||
        source.payWay ||
        source.payway ||
        source.provider ||
        source.pay_provider ||
        source.gateway ||
        (source.data && (source.data.pay_way || source.data.payWay || source.data.payway || source.data.provider || source.data.pay_provider || source.data.gateway)) ||
        source.type ||
        source.category ||
        ''
      ).toLowerCase();
    },
    isOnlinePaymentMethod(method) {
      const type = String((method && method.type) || '').toLowerCase();
      if (type === 'code_pay' || type === 'usdt_pay') return false;
      const channel = this.getMethodChannel(method);
      if (this.isUsdtChannel(method)) return false;
      return !!(
        (method && (method.is_online === 1 || method.is_online === true || method.online_pay === 1 || method.isOnline === true)) ||
        /(^|[_-])(online|onlinepay|online_pay|ruyi)([_-]|$)/.test(channel) ||
        channel === 'online' ||
        channel === 'online_pay'
      );
    },
    isUsdtChannel(method) {
      if (!method) return false;
      const type = String(method.type || '').toLowerCase();
      const payWay = String(method.pay_way || method.payWay || '').toLowerCase();
      const category = String(method.category || '').toLowerCase();
      return type === 'usdt_pay' || payWay === 'usdt' || payWay === 'usdt_pay' || category === 'usdt';
    },
    channelText(method) {
      const source = method || {};
      return [
        source.name,
        source.content,
        source.category,
        source.type,
        source.pay_way,
        source.payWay,
      ].join(' ').toLowerCase();
    },
    isWechatChannel(method) {
      if (!method || this.isUsdtChannel(method) || this.isOnlinePaymentMethod(method)) return false;
      const cate = String(method.category || method.type || '').toLowerCase();
      const payWay = String(method.pay_way || method.payWay || '').toLowerCase();
      return cate === 'wechat' || payWay === 'wechat' || payWay === 'wxpay' || /微信|wechat|wxpay/.test(this.channelText(method));
    },
    isAlipayChannel(method) {
      if (!method || this.isUsdtChannel(method) || this.isOnlinePaymentMethod(method)) return false;
      const cate = String(method.category || method.type || '').toLowerCase();
      const payWay = String(method.pay_way || method.payWay || '').toLowerCase();
      return cate === 'alipay' || payWay === 'alipay' || /支付宝|alipay/.test(this.channelText(method));
    },
    isOfflineQrChannel(method) {
      if (!method || this.isUsdtChannel(method) || this.isOnlinePaymentMethod(method)) return false;
      const type = String(method.type || '').toLowerCase();
      return type === 'code_pay' || this.isWechatChannel(method) || this.isAlipayChannel(method);
    },
    offlineChannelTag(method) {
      if (this.isWechatChannel(method)) return '微信线下';
      if (this.isAlipayChannel(method)) return '支付宝线下';
      return '线下扫码';
    },
    getChannelFallbackIcon(method) {
      if (this.isUsdtChannel(method)) {
        return '/static/image/1595237922936176.png';
      }
      if (this.isWechatChannel(method)) {
        return this.getDefaultIcon('wechat');
      }
      if (this.isAlipayChannel(method)) {
        return this.getDefaultIcon('alipay');
      }
      return '/static/image/iconXunipay@3x.png';
    },
    normalizePaymentMethod(item) {
      const source = item || {};
      const isUsdt = this.isUsdtChannel(source);
      const isOnline = !isUsdt && this.isOnlinePaymentMethod(source);
      const isWechat = !isUsdt && !isOnline && this.isWechatChannel(source);
      const isAlipay = !isUsdt && !isOnline && this.isAlipayChannel(source);
      const cate = source.category || this.currentTab || '';
      const fallback = this.getDefaultIcon(isUsdt ? 'usdt' : (isWechat ? 'wechat' : (isAlipay ? 'alipay' : (isOnline ? 'online' : cate))));
      let img = source.img || '';
      if (!img || img.endsWith('/uploads/') || img.endsWith('/uploads')) {
        img = fallback;
      }

      const remark = source.remark || (source.data && source.data.remark) || '';
      const downloadName = source.download_name || (source.data && source.data.download_name) || '';
      const downloadUrl = source.download_url || (source.data && source.data.download_url) || '';
      const channel = this.getMethodChannel(source);
      const codepayId = source.codepay_id || source.codepayId || (source.data && (source.data.codepay_id || source.data.codepayId)) || '';

      let bonus = '';
      if (source.bonus_ratio) {
        const bonusValue = Math.floor(parseFloat(source.bonus_ratio));
        bonus = `${this.$t('Bonus_Text')}${bonusValue}%`;
      }

      let offlineName = source.name || this.$t('Payment Method');
      if (isWechat && (!source.name || source.name === '支付方式')) offlineName = '微信扫码支付';
      if (isAlipay && (!source.name || source.name === '支付方式')) offlineName = '支付宝扫码支付';

      return {
        id: source.id || source.method_id || source.pay_id || codepayId || `${channel || cate}-${Math.random().toString(36).slice(2, 8)}`,
        type: source.type || (isUsdt ? 'usdt_pay' : (isOnline ? 'online_pay' : 'code_pay')),
        name: isUsdt
          ? (source.name || 'USDT离线支付')
          : (isOnline ? (source.name || source.title || '线上支付') : offlineName),
        category: isUsdt ? 'usdt' : (isWechat ? 'wechat' : (isAlipay ? 'alipay' : cate)),
        provider: source.provider || source.pay_provider || (source.data && (source.data.provider || source.data.pay_provider)) || '',
        pay_way: source.pay_way || source.payWay || source.payway || (source.data && (source.data.pay_way || source.data.payWay || source.data.payway)) || (isUsdt ? 'usdt' : (isOnline ? 'online_pay' : (isWechat ? 'wxpay' : (isAlipay ? 'alipay' : '')))),
        codepay_id: codepayId,
        pay_code: source.pay_code || source.payCode || (source.data && (source.data.pay_code || source.data.payCode)) || '',
        channel_code: source.channel_code || source.channelCode || source.pay_code || source.payCode || (isUsdt ? 'USDT' : (isWechat ? 'WECHAT' : (isAlipay ? 'ALIPAY' : ''))),
        amount_mode: source.amount_mode || (source.data && source.data.amount_mode) || 'range',
        channel: channel,
        img: img || fallback,
        amount: `${source.min_price}-${source.max_price}`,
        bonus: bonus,
        isFee: false,
        isOnline: isOnline,
        min_price: source.min_price,
        max_price: source.max_price,
        data: source.data,
        bonus_ratio: source.bonus_ratio,
        amount_list: source.amount_list || [],
        amount_ranges: source.amount_ranges || [],
        exchange_rate: source.exchange_rate,
        wallet_address: source.wallet_address,
        pay_qrcode: source.pay_qrcode,
        remark: remark,
        download_name: downloadName,
        download_url: downloadUrl
      };
    },
    resolvePayType(method) {
      if (!method) return 'alipay';
      if (method.isOnline) {
        return 'online_pay';
      }
      const cate = (method.category || (method.data && method.data.category) || method.channel || '').toLowerCase();
      if (method.type === 'usdt_pay' || cate === 'usdt' || method.pay_way === 'usdt' || method.pay_way === 'usdt_pay') return 'usdt';
      if (this.isWechatChannel(method) || cate === 'wechat') return 'wechat';
      if (this.isAlipayChannel(method) || cate === 'alipay') return 'alipay';
      if (cate === 'wallet') return 'bank';
      if (cate === 'online' || cate === 'online_pay') return 'online_pay';
      const explicitPayType = String(method.pay_way || method.payWay || '').toLowerCase();
      if (['bank', 'alipay', 'wechat', 'wxpay', 'usdt'].includes(explicitPayType)) {
        return explicitPayType === 'wxpay' ? 'wechat' : explicitPayType;
      }
      if (method.type === 'code_pay') return 'alipay';
      return 'alipay';
    },
    buildRechargePayload(method, amount) {
      const paytype = this.resolvePayType(method);
      const payload = {
        paytype: paytype === 'wechat' ? 'wxpay' : paytype,
        method_id: method.id,
        amount,
      };
      if (paytype === 'online_pay') {
        payload.pay_way = 'online_pay';
      } else {
        // 线下通道必须传后端 switch 支持的业务类型，不能传 code_pay/usdt_pay 等展示类型。
        payload.pay_way = paytype === 'wechat' ? 'wxpay' : paytype;
      }
      if (paytype === 'usdt') {
        payload.catepay = this.meyXi;
      }
      return payload;
    },
    normalizeRechargeResult(res) {
      const rawData = res && res.data && typeof res.data === 'object' ? res.data : {};
      const info = rawData.info && typeof rawData.info === 'object' ? rawData.info : {};
      const message = typeof res.message === 'string' || typeof res.message === 'number' ? String(res.message) : '';
      const deposit_no = rawData.deposit_no || rawData.order_no || rawData.out_trade_no || info.deposit_no || info.order_no || info.out_trade_no || message || '';
      const pay_url = rawData.pay_url || rawData.payUrl || rawData.redirect_url || rawData.url || info.pay_url || info.payUrl || info.redirect_url || info.url || '';
      return {
        raw: rawData,
        deposit_no: deposit_no ? String(deposit_no) : '',
        order_no: rawData.order_no || info.order_no || '',
        pay_url,
        pay_expire_at: rawData.pay_expire_at || rawData.expire_at || info.pay_expire_at || info.expire_at || '',
        pay_way: rawData.pay_way || rawData.payWay || info.pay_way || info.payWay || '',
      };
    },
    cachePendingOnlinePayment(payload, method) {
      if (typeof window === 'undefined' || !window.sessionStorage) return;
      try {
        const cache = Object.assign({}, payload, {
          payment_mode: 'online',
          method_id: method && method.id ? method.id : '',
          pay_way: payload.pay_way || (method && (method.pay_way || method.provider || method.channel)) || 'online_pay',
          provider: payload.provider || (method && method.provider) || 'online_pay',
        });
        window.sessionStorage.setItem('cs_pending_online_payment', JSON.stringify(cache));
      } catch (err) {
        // ignore storage failures
      }
    },
    redirectToOnlinePayment(order) {
      const targetUrl = this.getValidExternalPayUrl(order && order.pay_url);
      if (!targetUrl) {
        this.showTost(0, '支付链接无效，请稍后重试或联系客服');
        return;
      }

      // 线上支付必须直接进入三方收银台，避免先进入本地 payInfo 中间页。
      window.location.href = targetUrl;
    },
    getValidExternalPayUrl(rawUrl) {
      const value = String(rawUrl || '').trim();
      if (!value) return '';
      try {
        const URLCtor = typeof window !== 'undefined' && window.URL ? window.URL : URL;
        const parsed = new URLCtor(value);
        if (!['http:', 'https:'].includes(parsed.protocol) || !parsed.host) return '';
        return parsed.href;
      } catch (err) {
        return '';
      }
    },
    payTest() {
      let that = this;
      const method = that.selectedPaymentMethod || that.selectedMethod;

      if (!method) {
        that.showTost(0, '请选择支付通道');
        return;
      }

      that.selectPaymentMethod(method);
      const amount = Number(that.depositAmount);
      if (!amount) {
        that.showTost(0, '请输入充值金额');
        return;
      }

      if (!that.isAmountAllowed(amount)) {
        that.showTost(0, that.rangeHint || '当前金额不支持所选通道');
        return;
      }

      // USDT 地址以 T 开头默认 TRC20，其余走 ERC20，后端也会再根据地址判断。
      if (that.isUsdtChannel(method)) {
        const wallet = String(method.wallet_address || (method.data && method.data.wallet_address) || '');
        that.meyXi = /^T/i.test(wallet) ? 'TRC20' : (wallet ? 'ERC20' : 'TRC20');
      }

      const info = that.buildRechargePayload(method, amount);

      that.showLoading();
      that.$apiFun
        .post('/api/recharge', info)
        .then(res => {
          if (res.code != 200) {
            that.showTost(0, res.message);
            that.hideLoading();
            return;
          }
          if (res.code == 200) {
            const order = that.normalizeRechargeResult(res);
            const isOnlinePay = that.isOnlinePaymentMethod(method) || (!!order.pay_url && !that.isUsdtChannel(method));
            that.amount = null;
            that.depositAmount = '';
            that.hideLoading();

            if (isOnlinePay) {
              if (!order.pay_url) {
                that.showTost(0, '支付链接暂未返回，请稍后重试或联系客服');
                return;
              }
              that.cachePendingOnlinePayment(order, method);
              that.redirectToOnlinePayment(order);
              return;
            }

            const depositNo = order.deposit_no || res.message;
            that.$router.push({ path: `/payInfo?deposit_no=${depositNo}` });
            return;
          }
        })
        .catch(() => {
          that.hideLoading();
        });
    },
    changMey(val) {
      this.amount = val * 1;
    },
    getBanklist() {},
    changPayway() {},
    goNav(url) {
      this.$parent.goNav(url);
    },
    doCopy(msg) {
      let cInput = document.createElement('input');
      cInput.style.opacity = '0';
      cInput.value = msg;
      document.body.appendChild(cInput);
      cInput.select();
      document.execCommand('copy');
      this.showTost(1, this.$t('Copied successfully!'));
    },
    getUserInfo() {
      this.$parent.getUserInfo();
    },
    showLoading() {
      this.$parent.showLoading();
    },
    hideLoading() {
      this.$parent.hideLoading();
    },
    openKefu() {
      this.$parent.openKefu();
    },
    showTost(type, title) {
      this.$parent.showTost(type, title);
    },
    selectPaymentMethod(method) {
      this.selectedPaymentMethod = method;
      this.selectedMethod = method;
      this.min_price = method.min_price || 0;
      this.max_price = method.max_price || 0;
      this.pay_way = this.resolvePayType(method);
    },
    selectOnlineEntry() {
      if (!this.selectedPaymentMethod && this.availableChannels.length) {
        this.selectPaymentMethod(this.availableChannels[0]);
      }
    },
    confirmDeposit() {
      if (!this.canSubmit) {
        if (this.depositAmount) {
          this.showTost(0, this.rangeHint || '当前金额没有可用通道');
        }
        return;
      }
      this.payTest();
    },
    selectAmount(val) {
      this.amount = val;
      this.depositAmount = val;
    },
    formatAmount(val) {
      const num = parseFloat(val);
      if (isNaN(num)) return val;
      return num.toLocaleString('en-US');
    },
    isAmountInRange(value, range) {
      const amount = Number(value);
      if (!range || !isFinite(amount) || amount <= 0) return false;
      return amount >= Number(range.min_amount) && amount <= Number(range.max_amount);
    },
    isAmountAllowed(value, paymentMethod) {
      const method = paymentMethod || this.selectedPaymentMethod;
      const amount = Number(value);
      if (!method || !isFinite(amount) || amount <= 0) return false;

      const fixedAmounts = method.amount_list || [];
      if (method.amount_mode === 'fixed') {
        return fixedAmounts.some(item => Number(item.amount) === amount);
      }

      const ranges = method.amount_ranges || [];
      if (ranges.length) {
        return ranges.some(range => {
          return amount >= Number(range.min_amount) && amount <= Number(range.max_amount);
        });
      }

      return amount >= Number(method.min_price || 0) && amount <= Number(method.max_price || 0);
    },
    formatChannelRule(channel) {
      if (this.isOfflineQrChannel(channel) && channel.amount_ranges && channel.amount_ranges.length) {
        const labels = channel.amount_ranges.map((range) => {
          const min = this.formatAmount(range.min_amount);
          const max = this.formatAmount(range.max_amount);
          return Number(range.min_amount) === Number(range.max_amount) ? min : `${min}-${max}`;
        });
        return `${labels.join(' / ')} 元`;
      }
      if (channel.amount_mode === 'fixed' && channel.amount_list && channel.amount_list.length) {
        return `仅限 ${channel.amount_list.map(item => this.formatAmount(item.amount)).join(' / ')} 元`;
      }
      return `${this.formatAmount(channel.min_price)}-${this.formatAmount(channel.max_price)} 元`;
    },
    onOnlineIconError(e) {
      if (e && e.target && e.target.src.indexOf('/static/image/iconXunipay@3x.png') === -1) {
        e.target.src = '/static/image/iconXunipay@3x.png';
      }
    },
    onSelectedIconError(e) {
      const fallback = this.getChannelFallbackIcon(this.selectedChannel);
      if (e && e.target && fallback && e.target.src.indexOf(fallback) === -1) {
        e.target.src = fallback;
      }
    },
    onChannelIconError(e, channel) {
      const fallback = this.getChannelFallbackIcon(channel);
      if (e && e.target && fallback && e.target.src.indexOf(fallback) === -1) {
        e.target.src = fallback;
      }
    },
    onPayIconError(e, method) {
      const cate = (method && (method.category || (method.data && method.data.category))) || '';
      const fallback = this.getDefaultIcon(this.isUsdtChannel(method) ? 'usdt' : cate);
      if (e && e.target && fallback && e.target.src.indexOf(fallback) === -1) {
        e.target.src = fallback;
      }
    },
  },
  watch: {
    depositAmount(val) {
      this.amount = val === '' || val === null ? null : val * 1;
      if (this.selectedPaymentMethod && this.amount && !this.isAmountAllowed(this.amount, this.selectedPaymentMethod)) {
        this.selectedPaymentMethod = null;
        this.selectedMethod = null;
      }
    },
  },
  computed: {
    selectedChannel() {
      return this.selectedPaymentMethod || null;
    },
    selectedChannelIcon() {
      const channel = this.selectedChannel;
      return channel && channel.img ? channel.img : this.getChannelFallbackIcon(channel);
    },
    selectedChannelName() {
      const channel = this.selectedChannel;
      if (!channel) return '选择支付通道';
      if (this.isUsdtChannel(channel)) return channel.name || 'USDT离线支付';
      if (this.isOfflineQrChannel(channel)) return channel.name || this.offlineChannelTag(channel);
      return channel.name || '线上支付';
    },
    selectedRibbonText() {
      if (this.isUsdtChannel(this.selectedChannel) || this.isOfflineQrChannel(this.selectedChannel)) {
        return '上传凭证';
      }
      return '安全快捷';
    },
    selectedChannelSubtitle() {
      const channel = this.selectedChannel;
      if (!channel) return '微信 / 支付宝扫码 · 线上支付 / USDT线下';
      if (this.isUsdtChannel(channel)) {
        const rate = channel.exchange_rate ? `汇率 ${channel.exchange_rate}` : 'USDT线下';
        return `${rate} · ${this.formatChannelRule(channel)}`;
      }
      if (this.isOfflineQrChannel(channel)) {
        const ranges = channel.amount_ranges || [];
        if (ranges.length) {
          return `按金额匹配收款码 · ${this.formatChannelRule(channel)}`;
        }
        return `扫码转账后上传凭证 · ${this.formatChannelRule(channel)}`;
      }
      const code = channel.channel_code ? `编码 ${channel.channel_code}` : '已选择支付通道';
      return `${code} · ${this.formatChannelRule(channel)}`;
    },
    onlineEntryIcon() {
      const channel = this.paymentChannels.find(item => item.img);
      return channel ? channel.img : '/static/image/iconXunipay@3x.png';
    },
    availableChannels() {
      const amount = Number(this.depositAmount);
      if (!isFinite(amount) || amount <= 0) {
        return this.paymentChannels;
      }
      return this.paymentChannels.filter(channel => this.isAmountAllowed(amount, channel));
    },
    hasQuickAmounts() {
      return !!(this.selectedPaymentMethod && this.selectedPaymentMethod.amount_list && this.selectedPaymentMethod.amount_list.length);
    },
    canSubmit() {
      return !!this.selectedPaymentMethod && this.isAmountAllowed(this.amount, this.selectedPaymentMethod);
    },
    submitButtonText() {
      if (this.isUsdtChannel(this.selectedPaymentMethod)) {
        return '去转账并上传凭证';
      }
      if (this.isOfflineQrChannel(this.selectedPaymentMethod)) {
        return '去扫码并上传凭证';
      }
      return this.$t('Confirm Deposit');
    },
    usdtConvertHint() {
      const method = this.selectedPaymentMethod;
      if (!this.isUsdtChannel(method) || !this.amount) return '';
      const rate = Number(method.exchange_rate || 0);
      if (!rate || rate <= 0) return '转账完成后请上传支付凭证，等待后台审核';
      const usdtAmount = (Number(this.amount) / rate).toFixed(4);
      return `约需支付 ${usdtAmount} USDT（汇率 ${rate}），转账后上传凭证审核`;
    },
    rangeHint() {
      const method = this.selectedPaymentMethod;
      if (!method) {
        if (this.amount && this.availableChannels.length) {
          return `当前金额有 ${this.availableChannels.length} 个可用通道，请选择后支付`;
        }
        if (this.amount && !this.availableChannels.length) {
          return '当前金额没有可用通道，请调整金额';
        }
        return '请输入充值金额，系统会筛选可用通道';
      }
      if (this.isUsdtChannel(method)) {
        return `已选择 ${method.name}：${this.formatAmount(method.min_price)}-${this.formatAmount(method.max_price)} 元 · 线下转账后上传凭证`;
      }
      if (this.isOfflineQrChannel(method)) {
        const ranges = method.amount_ranges || [];
        if (ranges.length) {
          const labels = ranges.map((range) => {
            const min = this.formatAmount(range.min_amount);
            const max = this.formatAmount(range.max_amount);
            return Number(range.min_amount) === Number(range.max_amount) ? min : `${min}-${max}`;
          });
          return `已选择 ${method.name}：金额 ${labels.join('、')} 元会匹配对应收款码，付款后上传凭证`;
        }
        return `已选择 ${method.name}：${this.formatAmount(method.min_price)}-${this.formatAmount(method.max_price)} 元 · 扫码后上传凭证`;
      }
      if (method.amount_mode === 'fixed') {
        return `已选择 ${method.name}：${this.formatChannelRule(method)}`;
      }
      const ranges = method.amount_ranges || [];
      if (ranges.length) {
        const labels = ranges.map(range => {
          const min = this.formatAmount(range.min_amount);
          const max = this.formatAmount(range.max_amount);
          return Number(range.min_amount) === Number(range.max_amount) ? min : `${min}-${max}`;
        });
        return `可输入金额：${labels.join('、')} 元`;
      }
      return `已选择 ${method.name}：${this.formatAmount(method.min_price)}-${this.formatAmount(method.max_price)} 元`;
    }
  },
};
</script>

<style lang="scss" scoped>
/* 1. 沉浸式暗黑耀金全局背景 */
.background-gradient {
  background: radial-gradient(circle at top right, #2a2a2a, #0a0a0a) !important;
  min-height: 100vh;
  color: #e0e0e0;
}

.main {
  width: 100%;
  padding: 70px 15px 30px 15px; /* 适配顶部导航栏 */
  box-sizing: border-box;
}

.containerBlock {
  background: transparent;
  box-sizing: border-box;
}

.empty-tip {
  text-align: center;
  color: #888;
  padding: 24px 12px;
  font-size: 13px;
}

.amount-hint {
  margin-top: 12px;
  color: #999;
  font-size: 12px;
}

.usdt-convert-hint {
  margin-top: 12px;
  padding: 10px 12px;
  color: #9cf0d4;
  font-size: 12px;
  line-height: 1.5;
  background: rgba(38, 161, 123, 0.12);
  border: 1px solid rgba(38, 161, 123, 0.25);
  border-radius: 10px;
}

/* 2. 支付通道列表 (拟物浮雕卡片) */
.methodsDeposit {
  margin-bottom: 25px;
  
  .eWalletList {
    display: flex;
    flex-wrap: wrap;
    gap: 12px; /* 更优雅的网格间距 */
    
    .wallet-item {
      width: calc(33.33% - 8px); /* 一行三个 */
      height: 100px;
      background: linear-gradient(145deg, #2a2a2c, #1f1f21); /* 微弱的质感渐变 */
      border-radius: 14px;
      border: 1px solid rgba(255, 255, 255, 0.06);
      overflow: hidden;
      cursor: pointer;
      transition: all 0.3s ease;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      box-shadow: 4px 4px 10px rgba(0,0,0,0.4), -2px -2px 8px rgba(255,255,255,0.02); /* 新拟态浮雕 */
        
      &.active {
        background: #1a1a1a;
        border-color: #d1a03e; /* 金色边框 */
        box-shadow: 0 0 0 1px #d1a03e, 0 6px 15px rgba(209, 160, 62, 0.25); /* 耀金光晕 */
      }
        
      .bonus-ribbon {
        position: absolute;
        top: 0;
        left: 0;
        background: linear-gradient(135deg, #ff4d4d, #c60000);
        color: #fff;
        padding: 3px 8px;
        font-size: 11px;
        font-weight: bold;
        z-index: 10;
        border-radius: 0 0 10px 0;
        box-shadow: 2px 2px 6px rgba(0,0,0,0.3);
      }
      
      .method-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        
        .img-box {
          height: 38px;
          display: flex;
          align-items: center;
          margin-bottom: 8px;
          
          img {
            max-width: 50px;
            max-height: 100%;
            object-fit: contain;
            filter: drop-shadow(0 2px 4px rgba(0,0,0,0.3)); /* 图标立体感 */
          }
        }
        
        .method-name {
          font-size: 13px;
          font-weight: 500;
          color: #cccccc; /* 柔和白 */
          text-align: center;
        }
      }

      /* 右下角选中对勾 */
      .check-mark {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 0;
        height: 0;
        border-bottom: 24px solid #d1a03e;
        border-left: 24px solid transparent;
        
        &::after {
          content: '✓';
          position: absolute;
          right: 2px;
          bottom: -22px;
          color: #fff;
          font-size: 12px;
          font-weight: bold;
        }
      }
    }
  }
}

.online-entry-list {
  .wallet-item.online-entry {
    width: 100%;
    height: 108px;
    background: linear-gradient(135deg, #27272a 0%, #1a1a1c 100%);

    .method-content {
      .img-box {
        height: 44px;
        margin-bottom: 5px;
      }

      .method-name {
        color: #f5d77b;
        font-size: 15px;
      }

      .method-subtitle {
        margin-top: 3px;
        color: #8d8d92;
        font-size: 11px;
      }
    }

    &.usdt-entry {
      background: linear-gradient(135deg, #1f2a24 0%, #141a17 100%);
      border-color: rgba(38, 161, 123, 0.45);
      box-shadow: 0 0 0 1px rgba(38, 161, 123, 0.28), 0 6px 15px rgba(38, 161, 123, 0.18);

      .bonus-ribbon {
        background: linear-gradient(135deg, #26a17b, #0f7a58);
      }

      .method-content .method-name {
        color: #7ddebe;
      }

      .check-mark {
        border-bottom-color: #26a17b;
      }
    }

    &.offline-entry {
      background: linear-gradient(135deg, #2a2418 0%, #1a1610 100%);
      border-color: rgba(209, 160, 62, 0.5);
      box-shadow: 0 0 0 1px rgba(209, 160, 62, 0.28), 0 6px 15px rgba(209, 160, 62, 0.16);

      .bonus-ribbon {
        background: linear-gradient(135deg, #e0b15a, #a86128);
      }

      .method-content .method-name {
        color: #f5d77b;
      }

      .check-mark {
        border-bottom-color: #d1a03e;
      }
    }
  }
}

.channel-picker {
  margin-bottom: 25px;
  padding: 18px 16px 12px;
  background: linear-gradient(180deg, #242426 0%, #1a1a1c 100%);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 18px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.45);

  .channel-picker-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
    color: #fff;
    font-size: 15px;
    font-weight: 700;

    small {
      color: #b89d61;
      font-size: 11px;
      font-weight: 400;
    }
  }

  .channel-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .channel-card {
    display: flex;
    align-items: center;
    width: 100%;
    min-height: 64px;
    padding: 10px 11px;
    color: #dedede;
    text-align: left;
    background: rgba(255, 255, 255, 0.035);
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 12px;
    outline: none;
    cursor: pointer;
    transition: all 0.2s ease;

    &.active {
      background: rgba(209, 160, 62, 0.12);
      border-color: #d1a03e;
      box-shadow: 0 0 0 1px rgba(209, 160, 62, 0.35);
    }

    &.is-usdt {
      background: rgba(38, 161, 123, 0.08);
      border-color: rgba(38, 161, 123, 0.28);

      &.active {
        background: rgba(38, 161, 123, 0.16);
        border-color: #26a17b;
        box-shadow: 0 0 0 1px rgba(38, 161, 123, 0.35);
      }

      .channel-card-rule {
        color: #7ddebe;
      }
    }

    &.is-offline {
      background: rgba(209, 160, 62, 0.08);
      border-color: rgba(209, 160, 62, 0.28);

      &.active {
        background: rgba(209, 160, 62, 0.16);
        border-color: #d1a03e;
        box-shadow: 0 0 0 1px rgba(209, 160, 62, 0.35);
      }

      .channel-card-rule {
        color: #f5d77b;
      }

      .offline-tag {
        color: #fceb99;
        background: rgba(209, 160, 62, 0.22);
      }
    }

    .channel-card-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 0 0 38px;
      width: 38px;
      height: 38px;
      margin-right: 10px;
      overflow: hidden;
      background: #303034;
      border-radius: 10px;

      img {
        max-width: 28px;
        max-height: 28px;
        object-fit: contain;
      }
    }

    .channel-card-main {
      display: flex;
      flex: 1;
      min-width: 0;
      flex-direction: column;

      strong {
        overflow: hidden;
        color: #f2f2f2;
        font-size: 13px;
        font-weight: 600;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      em {
        margin-top: 4px;
        color: #8d8d92;
        font-size: 10px;
        font-style: normal;
      }
    }

    .channel-card-meta {
      display: flex;
      flex: 0 0 auto;
      flex-direction: column;
      align-items: flex-end;
      margin-left: 8px;
      gap: 4px;
    }

    .channel-tag {
      padding: 2px 6px;
      color: #9cf0d4;
      font-size: 10px;
      font-weight: 600;
      background: rgba(38, 161, 123, 0.22);
      border-radius: 999px;
    }

    .channel-card-rule {
      flex: 0 0 auto;
      color: #d8bd77;
      font-size: 11px;
      text-align: right;
    }

    .channel-card-arrow {
      margin-left: 8px;
      color: #9d9da2;
      font-size: 22px;
      line-height: 1;
    }
  }

  .channel-empty {
    padding: 16px 0 8px;
    color: #999;
    font-size: 12px;
    text-align: center;
  }
}

/* 4. 存款金额输入与快捷按钮 (高定面板) */
.depositAmountSet {
  margin-bottom: 30px;
  background: linear-gradient(180deg, #242426 0%, #1a1a1c 100%);
  border-radius: 20px;
  padding: 24px 20px;
  border: 1px solid rgba(255, 255, 255, 0.05);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.6);
  
  .amount-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    
    .title {
      font-size: 16px;
      font-weight: bold;
      color: #ffffff;
      letter-spacing: 0.5px;
    }

    .amount-header-tip {
      color: #8d8d92;
      font-size: 11px;
    }
    
    .download-btn {
      color: #fceb99; 
      padding: 6px 14px;
      border-radius: 20px;
      font-size: 12px;
      background: rgba(209, 160, 62, 0.1);
      border: 1px solid rgba(209, 160, 62, 0.4);
      text-decoration: none;
      transition: all 0.3s;
      
      &:hover {
        background: rgba(209, 160, 62, 0.25);
      }
    }
  }
  
  /* 沉浸式无边框金额输入 */
  .amount-input-wrapper {
    position: relative;
    margin-bottom: 25px;
    display: flex;
    align-items: flex-end;
    border-bottom: 2px solid rgba(255, 255, 255, 0.1);
    padding-bottom: 8px;
    transition: border-color 0.3s;

    &:focus-within {
      border-bottom-color: #d1a03e; /* 聚焦时底部亮起金线 */
    }
    
    .currency {
      font-size: 26px;
      color: #d1a03e; 
      font-weight: bold;
      margin-right: 10px;
      padding-bottom: 2px;
    }
    
    .amount-input {
      flex: 1;
      border: none;
      background: transparent;
      color: #ffffff; 
      font-size: 36px; /* 超大醒目字体 */
      font-weight: bold;
      outline: none;
      width: 100%;
      caret-color: #d1a03e; /* 光标也变成金色 */
      
      &::placeholder {
        color: rgba(255, 255, 255, 0.2);
        font-size: 18px;
        font-weight: normal;
        transform: translateY(-5px);
      }
      
      /* 隐藏自带恶心箭头 */
      &::-webkit-inner-spin-button,
      &::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
    }
    
    .payment-remark {
      position: absolute;
      right: 0;
      top: 5px;
      color: #888;
      font-size: 12px;
    }
  }
  
  /* 快捷金额芯片式按钮 */
  .quick-amount-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr); /* 4列更显宽敞 */
    gap: 12px;
    
    .quick-btn {
      background: rgba(255, 255, 255, 0.04);
      border: 1px solid rgba(255, 255, 255, 0.08);
      border-radius: 8px;
      padding: 12px 0;
      font-size: 15px;
      font-weight: 500;
      color: #bbbbbb;
      text-align: center;
      cursor: pointer;
      transition: all 0.3s;
      
      &.active {
        background: rgba(209, 160, 62, 0.12); /* 内部透出暗金光 */
        border: 1px solid #d1a03e; /* 金色边框 */
        color: #fceb99; /* 亮金色文字，不刺眼且高级 */
        font-weight: bold;
        box-shadow: 0 4px 10px rgba(209, 160, 62, 0.2);
      }
    }
  }

  .offline-range-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
    margin-top: 12px;

    .range-chip {
      padding: 10px 8px;
      color: #d8bd77;
      font-size: 12px;
      font-weight: 600;
      text-align: center;
      background: rgba(209, 160, 62, 0.08);
      border: 1px solid rgba(209, 160, 62, 0.28);
      border-radius: 8px;
      cursor: pointer;

      &.active {
        color: #4c2a10;
        background: linear-gradient(135deg, #fae9bf, #e0af55);
        border-color: #d1a03e;
      }
    }
  }
}

/* 5. 确认存款按钮 (奢华金脉冲) */
.submit-action {
  margin-bottom: 40px;
  
  .btn-submit {
    position: relative;
    width: 100%;
    height: 54px;
    background: linear-gradient(135deg, #ffe082 0%, #d1a03e 50%, #b8860b 100%); /* 渐变拉开层次 */
    color: #4a2e00; /* 极深咖色字 */
    border: none;
    border-radius: 14px;
    font-size: 18px;
    font-weight: 800;
    letter-spacing: 2px;
    cursor: pointer;
    overflow: hidden;
    box-shadow: 0 6px 20px rgba(209, 160, 62, 0.4), inset 0 2px 0 rgba(255, 255, 255, 0.4); /* 底部外发光 + 顶部内高光 */
    transition: all 0.3s;
    
    .btn-text {
      position: relative;
      z-index: 2;
      text-shadow: 0 1px 1px rgba(255,255,255,0.4); /* 文字立体感 */
    }
    
    /* 按钮上的流光效果 */
    .btn-light {
      position: absolute;
      top: 0;
      left: -100%;
      width: 50%;
      height: 100%;
      background: linear-gradient(to right, rgba(255,255,255,0) 0%, rgba(255,255,255,0.4) 50%, rgba(255,255,255,0) 100%);
      transform: skewX(-25deg);
      animation: sweep 3s infinite;
      z-index: 1;
    }
    
    &.disabled {
      background: #333333; 
      color: #666666;
      box-shadow: none;
      cursor: not-allowed;
      .btn-light { display: none; }
      .btn-text { text-shadow: none; }
    }
    
    &:active:not(.disabled) {
      transform: translateY(2px);
      box-shadow: 0 2px 10px rgba(209, 160, 62, 0.4);
    }
  }
}

/* 按钮流光动画 */
@keyframes sweep {
  0% { left: -100%; }
  20% { left: 200%; }
  100% { left: 200%; }
}

/* ==================== 白色多通道充值主题 ==================== */
.background-gradient {
  min-height: 100vh;
  background: #fff !important;
  color: #2d241d;
}

.main {
  padding: 64px 14px 92px;
}

.empty-tip,
.amount-hint {
  color: #8c7c6f;
}

.usdt-convert-hint {
  color: #1f7a5c;
  background: rgba(38, 161, 123, 0.08);
  border-color: rgba(38, 161, 123, 0.22);
}

.methodsDeposit {
  margin-bottom: 16px;
}

.methodsDeposit .eWalletList .wallet-item {
  border-color: #eadfd2;
  background: #fff;
  box-shadow: 0 7px 18px rgba(104, 69, 36, 0.09);
}

.methodsDeposit .eWalletList .wallet-item.active {
  border-color: #d8a64d;
  background: linear-gradient(140deg, #fffdf8 0%, #f7e7bd 100%);
  box-shadow: 0 8px 22px rgba(169, 103, 38, 0.17), inset 0 0 0 1px rgba(255, 255, 255, 0.55);
}

.online-entry-list .wallet-item.online-entry {
  height: 112px;
  border: 1px solid #d9aa54;
  background:
    radial-gradient(circle at 82% 18%, rgba(255, 255, 255, 0.92), rgba(255, 255, 255, 0) 30%),
    linear-gradient(135deg, #fffdf7 0%, #f8e8c1 54%, #edca7d 100%);
}

.online-entry-list .wallet-item.online-entry.usdt-entry {
  border-color: #49b48d;
  background:
    radial-gradient(circle at 82% 18%, rgba(255, 255, 255, 0.92), rgba(255, 255, 255, 0) 30%),
    linear-gradient(135deg, #f4fffa 0%, #d9f5e8 54%, #8ed9ba 100%);
  box-shadow: 0 8px 22px rgba(31, 122, 92, 0.14), inset 0 0 0 1px rgba(255, 255, 255, 0.55);

  .bonus-ribbon {
    background: linear-gradient(135deg, #26a17b, #14805d);
  }

  .method-content .method-name {
    color: #147556;
  }

  .method-content .method-subtitle {
    color: #4f8f78;
  }

  .check-mark {
    border-bottom-color: #26a17b;
  }
}

.online-entry-list .wallet-item.online-entry.offline-entry {
  border-color: #d9aa54;
  background:
    radial-gradient(circle at 82% 18%, rgba(255, 255, 255, 0.92), rgba(255, 255, 255, 0) 30%),
    linear-gradient(135deg, #fffdf7 0%, #f8e8c1 54%, #edca7d 100%);

  .bonus-ribbon {
    background: linear-gradient(135deg, #e0b15a, #a86128);
  }
}

.online-entry-list .wallet-item.online-entry .method-content .img-box {
  width: 48px;
  height: 48px;
  padding: 6px;
  border: 1px solid rgba(185, 121, 48, 0.20);
  border-radius: 13px;
  background: rgba(255, 255, 255, 0.72);
  box-shadow: 0 5px 13px rgba(113, 70, 26, 0.12);
  box-sizing: border-box;
}

.online-entry-list .wallet-item.online-entry .method-content .img-box img {
  max-width: 36px;
  max-height: 36px;
}

.online-entry-list .wallet-item.online-entry .method-content .method-name {
  color: #5d3517;
  font-size: 16px;
  font-weight: 800;
}

.online-entry-list .wallet-item.online-entry .method-content .method-subtitle {
  color: #8c6a4c;
}

.channel-picker,
.depositAmountSet {
  border: 1px solid #eadfd2;
  background: #fff;
  box-shadow: 0 9px 24px rgba(104, 69, 36, 0.10);
}

.channel-picker {
  margin-bottom: 18px;
  padding: 17px 15px 13px;
}

.channel-picker .channel-picker-header {
  color: #2d241d;
}

.channel-picker .channel-picker-header small {
  color: #9a6a38;
}

.channel-picker .channel-card {
  border: 1px solid #e9ded1;
  background: #fcfaf7;
  color: #4b4037;
  box-shadow: 0 3px 9px rgba(104, 69, 36, 0.05);
}

.channel-picker .channel-card.active {
  border-color: #d6a348;
  background: linear-gradient(135deg, #fffaf0, #f7e5bb);
  box-shadow: 0 5px 13px rgba(169, 103, 38, 0.14), inset 3px 0 0 #a86128;
}

.channel-picker .channel-card.is-usdt {
  border-color: #b7e4d2;
  background: #f4fbf8;
}

.channel-picker .channel-card.is-usdt.active {
  border-color: #49b48d;
  background: linear-gradient(135deg, #f3fffa, #d7f3e7);
  box-shadow: 0 5px 13px rgba(31, 122, 92, 0.14), inset 3px 0 0 #26a17b;
}

.channel-picker .channel-card.is-usdt .channel-card-rule {
  color: #1f7a5c;
}

.channel-picker .channel-card.is-offline {
  border-color: #ead3a4;
  background: #fffaf0;
}

.channel-picker .channel-card.is-offline.active {
  border-color: #d6a348;
  background: linear-gradient(135deg, #fffaf0, #f7e5bb);
  box-shadow: 0 5px 13px rgba(169, 103, 38, 0.14), inset 3px 0 0 #a86128;
}

.channel-picker .channel-card.is-offline .channel-card-rule {
  color: #a86128;
}

.channel-picker .channel-card .channel-tag {
  color: #147556;
  background: rgba(38, 161, 123, 0.14);
}

.channel-picker .channel-card .channel-tag.offline-tag {
  color: #8a5a22;
  background: rgba(209, 160, 62, 0.18);
}

.channel-picker .channel-card .channel-card-icon {
  border: 1px solid #eadfd2;
  background: #fff;
}

.channel-picker .channel-card .channel-card-main strong {
  color: #332820;
}

.channel-picker .channel-card .channel-card-main em {
  color: #95877b;
}

.channel-picker .channel-card .channel-card-rule {
  color: #8f5a28;
  font-weight: 600;
}

.channel-picker .channel-card .channel-card-arrow {
  color: #a78f79;
}

.channel-picker .channel-empty {
  color: #9b8d81;
}

.depositAmountSet {
  margin-bottom: 18px;
  padding: 22px 20px;
}

.depositAmountSet .amount-header .title {
  color: #2d241d;
}

.depositAmountSet .amount-header .amount-header-tip {
  color: #998b7f;
}

.depositAmountSet .amount-input-wrapper {
  border-bottom-color: #e4d8ca;
}

.depositAmountSet .amount-input-wrapper:focus-within {
  border-bottom-color: #b56f32;
}

.depositAmountSet .amount-input-wrapper .currency {
  color: #a86128;
}

.depositAmountSet .amount-input-wrapper .amount-input {
  color: #2d241d;
  caret-color: #a86128;
}

.depositAmountSet .amount-input-wrapper .amount-input::placeholder {
  color: #c4b9af;
}

.depositAmountSet .quick-amount-grid .quick-btn {
  border-color: #eadfd2;
  background: #fbf7f1;
  color: #74675d;
}

.depositAmountSet .quick-amount-grid .quick-btn.active {
  border-color: #d4a046;
  background: linear-gradient(135deg, #fae9bf, #e0af55);
  color: #603514;
  box-shadow: 0 4px 10px rgba(169, 103, 38, 0.16);
}

.depositAmountSet .offline-range-grid .range-chip {
  color: #8a5a22;
  background: #fffaf0;
  border-color: #ead3a4;
}

.depositAmountSet .offline-range-grid .range-chip.active {
  color: #603514;
  background: linear-gradient(135deg, #fae9bf, #e0af55);
  border-color: #d4a046;
}

.submit-action {
  margin-bottom: 20px;
}

.submit-action .btn-submit {
  background: linear-gradient(135deg, #f5d98e 0%, #dca84f 52%, #a86128 100%);
  color: #4c2a10;
  box-shadow: 0 8px 20px rgba(169, 103, 38, 0.25), inset 0 2px 0 rgba(255, 255, 255, 0.45);
}

.submit-action .btn-submit.btn-usdt {
  background: linear-gradient(135deg, #7ddebe 0%, #26a17b 55%, #147556 100%);
  color: #063528;
  box-shadow: 0 8px 20px rgba(38, 161, 123, 0.28), inset 0 2px 0 rgba(255, 255, 255, 0.35);
}

.submit-action .btn-submit.btn-offline {
  background: linear-gradient(135deg, #f5d98e 0%, #dca84f 52%, #a86128 100%);
  color: #4c2a10;
}

.submit-action .btn-submit.disabled {
  border: 1px solid #e4ddd5;
  background: #eeeae5;
  color: #aaa096;
}
</style>



// WEBPACK FOOTER //
// src/components/recharge.vue